import { createBrowserHistory } from 'history';
import Tracker from 'core/api/tracking/tracker';

export const history = createBrowserHistory();

history.listen(() => Tracker.trackPageView());

export default history;
